var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _line, _polygon40, _polygon41, _polygon42;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGem1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 268 251",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bi",
    x1: 0.09938,
    x2: 0.90159,
    y1: -0.06887,
    y2: 1.0691
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDCDCD",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.2474
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.5684
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#686868",
    offset: 0.8842
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9947
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bh",
    x1: 0.30297,
    x2: 0.84716,
    y1: 0.47732,
    y2: -0.24759
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7A7A7",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.5
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bf",
    cx: 185.67,
    cy: 108.44,
    r: 36.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767676",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "be",
    y1: 0.5,
    y2: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2947
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B4B4B",
    offset: 0.3211
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd",
    x1: 1,
    x2: 0,
    y1: 0.49991,
    y2: 0.49991
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.1737
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767676",
    offset: 0.6947
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bc",
    x1: 0.00024,
    y1: 0.50053,
    y2: 0.50053
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7A7A7",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb",
    x1: 0.42358,
    x2: 0.83534,
    y1: 0.27434,
    y2: 1.3197
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#585858",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ba",
    x1: 0.25069,
    x2: 0.57858,
    y1: 0.20431,
    y2: 0.85243
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C5C5",
    offset: 0.3316
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6B6B6",
    offset: 0.3368
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#959595",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x1: 0.22067,
    x2: 0.84407,
    y1: 0.35919,
    y2: 0.74481
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#595959",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    x1: 0.06479,
    x2: 0.5694,
    y1: 0.45824,
    y2: 0.50027
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7A7A7",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    x1: 0.10807,
    x2: 0.60301,
    y1: 0.83247,
    y2: 0.36501
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#898989",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    x1: 0.19925,
    x2: 0.79507,
    y1: 0.95901,
    y2: 0.1698
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7A7A7",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    y1: 0.49995,
    y2: 0.49995
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#595959",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    x1: 0.47849,
    x2: 0.6372,
    y1: 0.94555,
    y2: 0.09023
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7A7A7",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    y1: 0.50034,
    y2: 0.50034
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A5A5A",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x1: 0.0658,
    x2: 0.88419,
    y1: 0.01334,
    y2: 0.88181
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#494949",
    offset: 0.0632
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2D2D",
    offset: 0.1316
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#595959",
    offset: 0.1421
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "aq",
    cx: 66.894,
    cy: 164.93,
    r: 55.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9947
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: 0.42451,
    x2: 0.67039,
    y1: 0.00242,
    y2: 0.99851
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878787",
    offset: 0.3737
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#595959",
    offset: 0.3842
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: -0.01108,
    x2: 0.97736,
    y1: 0.9087,
    y2: 0.04009
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.6947
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ca",
    x1: 0.07689,
    x2: 0.66297,
    y1: 0.02291,
    y2: 0.80784
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0B0B0",
    offset: 0.2895
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C8C8C",
    offset: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bz",
    x1: 0.16203,
    x2: 1.2255,
    y1: 0.03569,
    y2: 0.75272
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1756
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#595959",
    offset: 0.1895
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "by",
    x1: 0.5,
    x2: 0.5,
    y1: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.6947
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bw",
    x1: 0.49958,
    x2: 0.49958,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7A7A7",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bv",
    x1: 0.46149,
    x2: 0.73664,
    y1: 0.15963,
    y2: 1.0848
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#545454",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bu",
    x1: -0.2433,
    x2: 0.65896,
    y1: 0.08743,
    y2: 0.99851
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767676",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bt",
    y1: 0.49997,
    y2: 0.49997
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2B2B",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bs",
    x1: 0.72156,
    x2: 0.01066,
    y1: 0.45671,
    y2: 0.59539
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "br",
    x1: 0.41552,
    x2: 0.93464,
    y1: 0.23067,
    y2: 0.92658
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#585858",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bq",
    x1: 0.38133,
    x2: 0.65404,
    y1: 0.91248,
    y2: 0.00785
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.6947
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bp",
    x2: 0.99985,
    y1: 0.4999,
    y2: 0.4999
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.6947
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bo",
    x1: 1,
    x2: 0,
    y1: 0.50006,
    y2: 0.50006
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.4842
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bn",
    x1: 0.48374,
    x2: 0.74455,
    y1: 0.40641,
    y2: 0.7599
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9947
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cb",
    y1: 0.50028,
    y2: 0.50028
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E2E2E",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bm",
    cx: 59.918,
    cy: 74.006,
    r: 32.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9947
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bl",
    x1: -0.04705,
    x2: 0.92626,
    y1: 0.37656,
    y2: 0.8802
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.1737
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767676",
    offset: 0.6947
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bk",
    x1: 0.4988,
    x2: 0.5027,
    y1: 0.03082,
    y2: 0.92704
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.2579
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767676",
    offset: 0.7579
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bj",
    x1: 0.29263,
    x2: 0.70608,
    y1: -0.13151,
    y2: 0.95781
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767676",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0.23511,
    x2: 0.86462,
    y1: 0.98387,
    y2: -0.16622
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7A7A7",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x1: 0.43197,
    x2: 0.53229,
    y1: 0.74767,
    y2: 0.06057
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#898989",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bx",
    x1: -0.07369,
    x2: 1.2867,
    y1: 0.08475,
    y2: 0.84664
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0684
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1756
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#595959",
    offset: 0.1895
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    offset: 1
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "93.892 68.589 156.95 86.237 212.17 84.081 228.64 62.352 195.38 35.414 133.63 17.918 75.719 20.74 60.772 42.11",
    fill: "url(#bi)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "212.17 84.081 184.79 108.04 156.95 86.237",
    fill: "url(#bh)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "184.79 108.04 188.28 140.2 208.9 144.39",
    fill: "url(#bf)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "184.79 108.04 150.16 138.32 169.12 144.46 188.28 140.2",
    fill: "url(#be)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "150.16 138.32 127.9 139.22 108.62 127.16 118.05 98.547",
    fill: "url(#bd)"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "127.9 139.22 148.42 147.79 169.12 144.46 150.16 138.32",
    fill: "url(#bc)"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "127.9 139.22 106.02 138.32 85.921 126.91 108.62 127.16",
    fill: "#EFEFEF"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "169.12 144.47 184.61 149.24 208.9 144.39 188.28 140.2",
    fill: "url(#bb)"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "118.05 98.547 93.892 68.589 59.495 73.896 67.083 114.67",
    fill: "url(#ba)"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "60.772 42.11 51.272 39.053 37.507 51.986 21.595 86.861 59.495 73.896 60.731 43.14",
    fill: "url(#az)"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "37.507 51.986 19.17 77.726 21.595 86.861",
    fill: "url(#ay)"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "21.595 86.861 33.076 96.131 59.495 73.896",
    fill: "url(#ax)"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "33.076 96.131 45.421 100.78 59.495 73.896",
    fill: "url(#aw)"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "27.77 97.502 33.076 96.131 21.595 86.861",
    fill: "url(#au)"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "67.083 114.67 59.495 73.896 45.421 100.78 53.996 112.22",
    fill: "url(#at)"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "85.898 126.99 67.083 125.02 53.996 112.22 67.083 114.67",
    fill: "url(#as)"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "27.77 97.502 77.439 178.12 42.454 111.22 33.076 96.131",
    fill: "url(#ar)"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "106.02 232.35 27.77 97.502 77.439 178.12",
    fill: "url(#aq)"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "106.02 191.14 67.083 125.02 77.439 178.12 106.02 232.35",
    fill: "url(#ap)"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "148.42 147.79 140.81 195.5 106.02 232.35 106.02 191.14",
    fill: "url(#ao)"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "106.02 138.32 106.02 191.14 148.42 147.79 127.9 139.22",
    fill: "url(#ca)"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "67.083 125.02 85.898 126.99 106.02 138.32 106.02 191.14",
    fill: "url(#bz)"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "148.42 147.79 169.12 144.46 184.61 149.24 140.81 195.5",
    fill: "url(#by)"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "208.92 144.54 223.44 138.32 236.52 138.37 220.53 146.46",
    fill: "#EFEFEF"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "242.47 126.91 236.52 138.37 248.53 124.79",
    fill: "url(#bw)"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "223.44 138.32 184.79 108.04 212.17 84.081 229.71 91.496",
    fill: "url(#bv)"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "242.47 126.91 229.71 91.496 223.44 138.32 236.52 138.37",
    fill: "url(#bu)"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "228.64 62.352 229.71 91.496 212.17 84.081",
    fill: "url(#bt)"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "245.52 105.02 229.71 91.496 228.64 62.352 237.96 77.52",
    fill: "url(#bs)"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "246.73 109.45 248.53 124.79 242.47 126.91 229.71 91.496 245.52 105.02",
    fill: "url(#br)"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "220.53 146.46 140.81 195.5 184.61 149.24 208.92 144.54",
    fill: "url(#bq)"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "236.52 138.37 220.53 146.46 168.83 187.12",
    fill: "url(#bp)"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "106.02 232.35 168.83 187.12 220.53 146.46 140.81 195.5",
    fill: "url(#bo)"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "51.272 39.053 60.772 42.11 75.719 20.74",
    fill: "url(#bn)"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "33.076 96.131 45.421 100.78 53.996 112.22 42.454 111.22",
    fill: "url(#cb)"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "59.495 73.896 93.892 68.589 60.772 42.11",
    fill: "url(#bm)"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "156.95 86.237 118.05 98.547 93.892 68.589",
    fill: "url(#bl)"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "118.05 98.547 156.95 86.237 184.79 108.04 150.16 138.32",
    fill: "url(#bk)"
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "184.79 108.04 223.44 138.32 208.92 144.54",
    fill: "url(#bj)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    transform: "translate(-.003 .003)",
    x1: 118.05,
    x2: 67.083,
    y1: 98.547,
    y2: 114.67,
    fill: "url(#bg)"
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "108.62 127.16 85.921 126.91 67.083 114.67 118.05 98.547",
    fill: "url(#av)"
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "53.996 112.22 42.454 111.22 77.439 178.12 67.083 125.02",
    fill: "url(#bx)"
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    transform: "translate(-.003 .003)",
    points: "246.73 109.45 237.96 77.52 228.64 62.352 195.38 35.414 133.63 17.918 75.719 20.74 51.272 39.053 37.507 51.986 19.17 77.726 21.595 86.861 106.02 232.35 236.52 138.37 248.53 124.79",
    fill: "#ff007f",
    opacity: 0.28
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGem1);
export default __webpack_public_path__ + "static/media/gem1.6fda12a1f103d5f70762fce02cb1f557.svg";
export { ForwardRef as ReactComponent };